import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import Tabs from 'antd/es/tabs';

import MainLayout from 'layouts/Main.layout';
import { Row, Col } from 'components/layout';
import PageHeader from 'components/PageHeader';

// tabs
import TackingTab from '../tabs/Tracking.tab';
// import FlowTab from '../tabs/Flow.tab';

const dcMapTabs = [
  {
    key: 'tracking',
    title: 'Tracking',
    component: TackingTab,
  },
  // {
  //   key: 'flow',
  //   title: 'Flow',
  //   component: FlowTab,
  // },
];

const DCMapPage = () => {
  const history = useHistory();
  const tabs = useMemo(() => dcMapTabs, []);
  
  const defaultActiveKey = useMemo(() => {
    const activeKey = history.location.hash.substr(1);
    return activeKey || tabs[0]?.key;
  }, [history.location, tabs]);

  const onTabChange = useCallback((key) => {
    history.replace(`#${key}`);
  }, [history]);

  return (
    <MainLayout>
      <PageHeader
        title="Map View"
        icon="map-pin"
        subTitle={null}
      />
      <Row style={{ padding: '24px 32px 0 32px', height: 'calc(100% - 84px)' }}>
        <Col span={24}>
          <DCMapTabs defaultActiveKey={defaultActiveKey} onChange={onTabChange}>
            {tabs.map(({ key, title, component: Component }) => (
              <Tabs.TabPane key={key} tab={title}>
                <Component />
              </Tabs.TabPane>
            ))}
          </DCMapTabs>
        </Col>
      </Row>
    </MainLayout>
  );
};

const DCMapTabs = styled(Tabs)`
  background-color: #fff;
  height: 100%;

  & .ant-tabs-tab {
    padding: 16px;
    margin: 0 16px 0 0;
    font-size: 15px;
  }

  & .ant-tabs-nav {
    margin-bottom: 24px;
  }

  & .ant-tabs-content-holder {
    padding: 16px;
  }
`;


export default DCMapPage;